import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const Contact = () => {
  React.useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-slide-in');
        }
      });
    }, observerOptions);

    const elements = document.querySelectorAll('.scroll-animate');
    elements.forEach((el) => observer.observe(el));

    return () => {
      elements.forEach((el) => observer.unobserve(el));
    };
  }, []);

  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-black to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Contact Your Tampa Bay <span className="text-red-500">Handyman</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Need a handyman in Tampa, Brandon, Riverview, or surrounding areas? We're here to help with all your home repair and installation needs.
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <Card className="scroll-animate bg-black/50 border-red-900/30">
              <CardContent className="p-6 text-center">
                <Phone className="w-12 h-12 text-red-500 mx-auto mb-4" />
                <h3 className="text-white font-bold mb-2">Call Us</h3>
                <a href="tel:8134491138" className="text-gray-300 hover:text-red-500 transition-colors">
                  (813) 449-1138
                </a>
              </CardContent>
            </Card>

            <Card className="scroll-animate bg-black/50 border-red-900/30">
              <CardContent className="p-6 text-center">
                <Mail className="w-12 h-12 text-red-500 mx-auto mb-4" />
                <h3 className="text-white font-bold mb-2">Email Us</h3>
                <a href="mailto:info@swifthandymen.com" className="text-gray-300 hover:text-red-500 transition-colors break-all">
                  info@swifthandymen.com
                </a>
              </CardContent>
            </Card>

            <Card className="scroll-animate bg-black/50 border-red-900/30">
              <CardContent className="p-6 text-center">
                <MapPin className="w-12 h-12 text-red-500 mx-auto mb-4" />
                <h3 className="text-white font-bold mb-2">Service Area</h3>
                <p className="text-gray-300">
                  Tampa Bay & Surrounding Areas
                </p>
              </CardContent>
            </Card>

            <Card className="scroll-animate bg-black/50 border-red-900/30">
              <CardContent className="p-6 text-center">
                <Clock className="w-12 h-12 text-red-500 mx-auto mb-4" />
                <h3 className="text-white font-bold mb-2">Hours</h3>
                <p className="text-gray-300">
                  7 Days a Week<br />
                  7AM - 7PM
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <ContactSection />

      {/* Service Areas List */}
      <section className="py-16 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-white mb-8">
            Professional Handyman Services Available In:
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 text-center">
            {[
              'Tampa, FL',
              'Brandon, FL',
              'Riverview, FL',
              'Clearwater, FL',
              'St. Petersburg, FL',
              'Temple Terrace, FL',
              'Plant City, FL',
              'Valrico, FL',
              'Seffner, FL',
              'Westchase, FL',
              'Carrollwood, FL',
              'Town n Country, FL'
            ].map((city, index) => (
              <div key={index} className="text-gray-300 bg-black/30 p-3 rounded border border-red-900/20">
                {city}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
